// const BACKEND_ENDPOINT = "http://localhost:8081"
const BACKEND_ENDPOINT = "https://api.parsableweb.com"
const ASSETS_ENDPOINT = "https://content.parsableweb.com"

export default {
    BACKEND_ENDPOINT: BACKEND_ENDPOINT,
    ASSETS_ENDPOINT: ASSETS_ENDPOINT
}